import {loadLibrary} from "./Util";
import {LIB_URL} from '../App';

const $stickyBlocks = $('.js-sticky');

// если есть прилипающие блоки и нет табов, тогда делаем инит прилипающих блоков. если есть табы, то инит делаем в Tabs.js
if ($stickyBlocks.length && !$('.js-tabs').length) {
    App.D.ready(function() {
        setTimeout(function() {
            initStickyBlocks();
        }, 1000);
    });
}

export function initStickyBlocks() {
    loadLibrary(LIB_URL.STICKY, () => {
        $stickyBlocks.stickySidebar({
            topSpacing: function() {
                let stickyTopValue = $('.js-mobile-menu').is(":hidden") ? ($('.header-wrap').outerHeight() + $('.js-breadcrumbs').outerHeight()) : ($('.js-mobile-menu').outerHeight() + $('.js-breadcrumbs').outerHeight());;
                return stickyTopValue;
            },
            resizeSensor: true,
            stickyClass: 'is-affixed',
            containerSelector: '.js-sticky-wrapper',
        });
    });
}
